import { NextPageContext } from 'next';
import { useRedirectToMain } from '@/hooks/useRedirectToMain';
import GlobalError from '@/components/screens/global-error/GlobalError';

type Props = {
  statusCode: number;
  message?: string;
};

const ErrorPage = ({ statusCode, message }: Props) => {
  useRedirectToMain(true);

  return <GlobalError statusCode={statusCode} message={message} />;
};

ErrorPage.getInitialProps = ({ res, err }: NextPageContext) => {
  const statusCode = res?.statusCode || err?.statusCode || 500;
  const message = err?.message || undefined;

  console.table(`Error ${statusCode}: ${message}. Page: ${res?.req.url}`);

  return { statusCode, message };
};

export default ErrorPage;
